import loginActions from "./store/login-actions";
import loginState from "./store/login-state";
import loginMutations from "./store/login-mutations";
import loginGetters from "./store/login-getters";

/* This is the syntax for creating a Vuex module of authentication proccess. */
const auth = {
  namespaced: true,
  state: loginState,
  actions: loginActions,
  mutations: loginMutations,
  getters: loginGetters
};

export { auth };
